module.exports = __webpack_public_path__ + "img/user.38d41250.svg";